import Styles from './BasicContactInfo.module.scss';

import { ReactComponent as CallIcon } from "../../../icons/extra_icons/call.svg"
import { ReactComponent as MessageIcon } from "../../../icons/extra_icons/message.svg"
import { ReactComponent as VideoIcon } from "../../../icons/extra_icons/video.svg"
import { ReactComponent as MailIcon } from "../../../icons/extra_icons/mail.svg"


//Redux
import { useDispatch } from 'react-redux';
import { openWindow } from '../../../actions';
import { APP_KEY_IDS } from '../../../constants/constants';


interface BasicContactInfoProps {
    label: string;
    phone: string;
    work: string;
    facetime: string;
    birthday: string;
    home: string;
    pfp: string;
    designation: string
}
const BasicContactInfo = ({
    label,
    phone,
    work,
    facetime,
    birthday,
    home,
    pfp,
    designation }: BasicContactInfoProps
) => {

    const dispatch = useDispatch()


    const contactPlaforms = [
        {
            id: 0,
            label: "message",
            icon: <MessageIcon />,
            onClick: () => { dispatch(openWindow(APP_KEY_IDS.MESSAGES)) }
        },
        {
            id: 1,
            label: "call",
            icon: <CallIcon />,
            onClick: () => { }
        },
        {
            id: 2,
            label: "video",
            icon: <VideoIcon />,
            onClick: () => { }
        },
        {
            id: 3,
            label: "mail",
            icon: <MailIcon />,
            onClick: () => { window.location.href = "mailto:priyansh.sk80@gmail.com"; }
        }
    ]

    return (
        <div className={Styles.container}>
            <div className={Styles.header}>
                <div className={Styles.profile}>
                    <img src={pfp || "https://firebasestorage.googleapis.com/v0/b/priyanshdatyal-me.appspot.com/o/website%20resources%2Fportfolio_profile_picture.webp?alt=media&token=8396fd2a-7b6e-452d-866b-b0aecf5077f0"} />
                </div>
                <div className={Styles.info}>

                    <div className={Styles.name}>{label}</div>
                    <div className={Styles.designation}>{designation}</div>

                </div>
            </div>

            <div className={Styles.contact_flex}>
                {
                    contactPlaforms.map((platform: any) => {
                        return (
                            <div className={Styles.tile} onClick={platform.onClick} key={platform.id}>
                                <div className={Styles.icon}>
                                    {platform.icon}
                                </div>
                                <div className={Styles.label}>
                                    {platform.label}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <div className={Styles.text_info_container}>
                <div className={Styles.info_text}>
                    <div className={Styles.key}>phone</div>
                    <div className={Styles.value}>{phone}</div>
                </div>
                <div className={Styles.info_text}>
                    <div className={Styles.key}>work</div>
                    <div className={Styles.value}>{work}</div>
                </div>
                <div className={Styles.divider} />
                <div className={Styles.info_text}>
                    <div className={Styles.key}>Facetime</div>
                    <div className={Styles.value}>
                        <VideoIcon/>
                        <CallIcon/>
                    </div>
                </div>
                <div className={Styles.divider} />
                <div className={Styles.info_text}>
                    <div className={Styles.key}>work</div>
                    <div className={Styles.value}>{work}</div>
                </div>
                <div className={Styles.divider} />
                <div className={Styles.info_text}>
                    <div className={Styles.key}>birthday</div>
                    <div className={Styles.value}>{birthday}</div>
                </div>
                <div className={Styles.divider} />
                <div className={Styles.info_text}>
                    <div className={Styles.key}>home</div>
                    <div className={Styles.value}>{home}</div>
                </div>
            </div>
        </div>
    )
}

export default BasicContactInfo
